// @ts-nocheck
/*
 * Rarely Cart Recommendations
 *
 * Catalog-wide cart discovery powered by Shopify's live Product Recommendations
 * endpoint, with Rarely's curated accessory map layered above it. Shopify remains
 * the authority for product, variant, price, and availability data.
 */
(function (root) {
  'use strict';

  var EXCLUDED_TAGS = [
    'exclude-from-cart-recommendations',
    'exclude-from-recommendations',
    'hidden',
    'wholesale-only'
  ];

  var INTEREST_COPY = {
    pets: 'A useful companion for the dog gear already in your cart.',
    outdoors: 'Belongs in the same field kit.',
    workshop: 'Made for the same working kit.',
    kitchen: 'A natural companion in the kitchen.',
    desk: 'A tidy companion for the desk.',
    garden: 'Useful for the same time outdoors.',
    kids: 'Extends the same kind of play.',
    play: 'Extends the same kind of play.',
    baby: 'A soft companion for the same little world.',
    travel: 'Easy to keep in the same travel kit.',
    grooming: 'Fits the same daily ritual.',
    home: 'A practical companion for the home.',
    camping: 'Belongs in the same camp kit.',
    fitness: 'Made for the same training space.'
  };
  var GET_CACHE_TTL = 10000;
  var getCache = new Map();

  function toString(value) {
    return value == null ? '' : String(value);
  }

  function unique(list) {
    var seen = Object.create(null);
    return (list || []).filter(function (value) {
      var key = toString(value).toLowerCase();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return unique(tags.map(function (tag) { return toString(tag).trim(); }));
    if (!tags) return [];
    return unique(toString(tags).split(',').map(function (tag) { return tag.trim(); }));
  }

  function normalizeVariant(variant) {
    variant = variant || {};
    return {
      id: toString(variant.id),
      title: toString(variant.title || 'Default Title'),
      available: variant.available !== false && variant.available_for_sale !== false,
      price: Number(variant.price || 0),
      compareAtPrice: Number(variant.compare_at_price || 0),
      options: Array.isArray(variant.options) ? variant.options.map(toString) : [],
      featuredImage: variant.featured_image || variant.featured_media || null
    };
  }

  function normalizeProduct(product) {
    product = product || {};
    var variants = (product.variants || []).map(normalizeVariant);
    var available = product.available !== false && variants.some(function (variant) { return variant.available; });
    var productType = product.product_type != null ? product.product_type : (product.type != null ? product.type : product.productType);
    var featuredImage = product.featured_image || product.featuredImage;
    if (featuredImage && typeof featuredImage === 'object') {
      featuredImage = featuredImage.src || featuredImage.url || featuredImage.preview_image && featuredImage.preview_image.src;
    }
    var price = Number(product.price || 0);
    if (!price && variants.length) {
      price = variants.reduce(function (lowest, variant) {
        if (!variant.available) return lowest;
        if (!lowest || variant.price < lowest) return variant.price;
        return lowest;
      }, 0);
    }
    return {
      id: toString(product.id),
      handle: toString(product.handle).toLowerCase(),
      title: toString(product.title),
      vendor: toString(product.vendor),
      productType: toString(productType),
      tags: normalizeTags(product.tags),
      available: available,
      featuredImage: featuredImage || '',
      url: toString(product.url || (product.handle ? '/products/' + product.handle : '')),
      price: price,
      compareAtPrice: Number(product.compare_at_price != null ? product.compare_at_price : (product.compareAtPrice || 0)),
      variants: variants,
      options: Array.isArray(product.options) ? product.options.map(toString) : [],
      sourceRank: Number(product.sourceRank || 0),
      sourceCount: Number(product.sourceCount || 1),
      discoverySignal: Number(product.discoverySignal || 0),
      sourceProductIds: unique((product.sourceProductIds || []).map(toString)),
      curated: product.curated === true,
      curatedRule: product.curatedRule || null
    };
  }

  function availableVariants(product) {
    return normalizeProduct(product).variants.filter(function (variant) {
      return variant.available && variant.id;
    });
  }

  function interestTokens(product) {
    var normalized = normalizeProduct(product);
    return unique(normalized.tags.map(function (tag) {
      var match = tag.toLowerCase().match(/^gift:interest:(.+)$/);
      return match ? match[1] : '';
    }).filter(Boolean));
  }

  function sharedInterests(anchor, candidate) {
    var anchorInterests = interestTokens(anchor);
    var candidateInterests = interestTokens(candidate);
    return anchorInterests.filter(function (interest) {
      return candidateInterests.indexOf(interest) !== -1;
    });
  }

  function segmentTokens(product) {
    var normalized = normalizeProduct(product);
    return unique(normalized.tags.map(function (tag) {
      var match = tag.toLowerCase().match(/^rarely_(?:primary_)?segment:(.+)$/);
      return match ? match[1] : '';
    }).filter(Boolean));
  }

  function sharedSegments(anchor, candidate) {
    var anchorSegments = segmentTokens(anchor);
    var candidateSegments = segmentTokens(candidate);
    return anchorSegments.filter(function (segment) {
      return candidateSegments.indexOf(segment) !== -1;
    });
  }

  function usefulVendor(value) {
    var vendor = toString(value).trim().toLowerCase();
    if (!vendor || vendor === 'rarely' || vendor === 'rarely marketplace' || /^\d+$/.test(vendor)) return '';
    return vendor;
  }

  function sameUsefulVendor(left, right) {
    var leftVendor = usefulVendor(left);
    return Boolean(leftVendor && leftVendor === usefulVendor(right));
  }

  function isHandleSibling(left, right) {
    left = toString(left).toLowerCase();
    right = toString(right).toLowerCase();
    if (!left || !right || left === right) return false;
    return left.indexOf(right + '-') === 0 || right.indexOf(left + '-') === 0;
  }

  function contextualSignalScore(candidate, anchors) {
    candidate = normalizeProduct(candidate);
    var score = candidate.discoverySignal;
    (anchors || []).forEach(function (anchorRaw) {
      var anchor = normalizeProduct(anchorRaw);
      score += sharedInterests(anchor, candidate).length * 100;
      score += sharedSegments(anchor, candidate).length * 90;
      if (sameUsefulVendor(anchor.vendor, candidate.vendor)) score += 80;
      if (anchor.productType && candidate.productType && anchor.productType.toLowerCase() === candidate.productType.toLowerCase()) score += 50;
      var candidateTitleTokens = titleTokens(candidate);
      score += titleTokens(anchor).filter(function (token) { return candidateTitleTokens.indexOf(token) !== -1; }).length * 30;
    });
    if (candidate.sourceCount > 1) score += 45;
    return score;
  }

  function hasExcludedTag(product) {
    var tags = normalizeProduct(product).tags.map(function (tag) { return tag.toLowerCase(); });
    return EXCLUDED_TAGS.some(function (excluded) { return tags.indexOf(excluded) !== -1; });
  }

  function isGiftCard(product) {
    var normalized = normalizeProduct(product);
    return normalized.productType.toLowerCase() === 'gift card' ||
      normalized.handle.indexOf('gift-card') !== -1 ||
      normalized.tags.map(function (tag) { return tag.toLowerCase(); }).indexOf('gift-card') !== -1;
  }

  function cartHas(cartProductIds, id) {
    if (!cartProductIds) return false;
    if (typeof cartProductIds.has === 'function') return cartProductIds.has(toString(id));
    return Array.isArray(cartProductIds) && cartProductIds.map(toString).indexOf(toString(id)) !== -1;
  }

  function scoreCandidate(candidate, anchors) {
    var score = 0;
    var normalized = normalizeProduct(candidate);
    if (normalized.curated) score += 10000 + Math.max(0, -normalized.sourceRank) * 20;
    score += Math.max(0, normalized.sourceCount - 1) * 180;
    score += Math.max(0, 80 - normalized.sourceRank * 6);

    (anchors || []).forEach(function (anchorRaw) {
      var anchor = normalizeProduct(anchorRaw);
      var interests = sharedInterests(anchor, normalized);
      score += interests.length * 95;
      score += sharedSegments(anchor, normalized).length * 110;
      if (sameUsefulVendor(anchor.vendor, normalized.vendor)) score += 75;
      if (anchor.productType && normalized.productType && anchor.productType.toLowerCase() === normalized.productType.toLowerCase()) score += 45;
      if (anchor.price && normalized.price && normalized.price <= Math.max(8000, anchor.price * 0.65)) score += 20;
    });

    if (availableVariants(normalized).length === 1) score += 12;
    return score;
  }

  function bestAnchor(candidate, anchors) {
    var normalized = normalizeProduct(candidate);
    var best = null;
    var bestScore = -1;
    (anchors || []).forEach(function (anchorRaw) {
      var anchor = normalizeProduct(anchorRaw);
      var score = sharedInterests(anchor, normalized).length * 10;
      score += sharedSegments(anchor, normalized).length * 8;
      if (sameUsefulVendor(anchor.vendor, normalized.vendor)) score += 5;
      if (anchor.productType && normalized.productType && anchor.productType.toLowerCase() === normalized.productType.toLowerCase()) score += 3;
      if (score > bestScore) {
        bestScore = score;
        best = anchor;
      }
    });
    return best;
  }

  function rationaleFor(candidate, anchors) {
    var normalized = normalizeProduct(candidate);
    if (normalized.curatedRule && normalized.curatedRule.note) return toString(normalized.curatedRule.note);
    var anchor = bestAnchor(normalized, anchors);
    if (!anchor) return 'Selected to complement what is already in your cart.';
    if (sameUsefulVendor(anchor.vendor, normalized.vendor)) {
      return 'Made by ' + normalized.vendor + ' to live alongside it.';
    }
    var interests = sharedInterests(anchor, normalized);
    if (interests.length && INTEREST_COPY[interests[0]]) return INTEREST_COPY[interests[0]];
    if (sharedSegments(anchor, normalized).length) return 'Chosen from the same part of the collection.';
    if (anchor.productType && normalized.productType && anchor.productType.toLowerCase() === normalized.productType.toLowerCase()) {
      return 'Another well-made piece from the same product world.';
    }
    return 'Selected to complement what is already in your cart.';
  }

  function mergeCandidates(candidates) {
    var byKey = Object.create(null);
    (candidates || []).forEach(function (raw) {
      var candidate = normalizeProduct(raw);
      var key = candidate.id || candidate.handle;
      if (!key) return;
      if (!byKey[key]) {
        byKey[key] = candidate;
        return;
      }
      var current = byKey[key];
      current.sourceRank = Math.min(current.sourceRank, candidate.sourceRank);
      current.sourceCount += candidate.sourceCount || 1;
      current.discoverySignal = Math.max(current.discoverySignal || 0, candidate.discoverySignal || 0);
      current.sourceProductIds = unique(current.sourceProductIds.concat(candidate.sourceProductIds));
      if (candidate.curated) {
        current.curated = true;
        current.curatedRule = candidate.curatedRule || current.curatedRule;
      }
    });
    return Object.keys(byKey).map(function (key) { return byKey[key]; });
  }

  function selectCandidates(config) {
    config = config || {};
    var anchors = (config.anchors || []).map(normalizeProduct);
    var limit = Number(config.limit || 3);
    return mergeCandidates(config.candidates || [])
      .filter(function (candidate) {
        if (!candidate.id || !candidate.handle || !candidate.title || !candidate.available) return false;
        if (cartHas(config.cartProductIds, candidate.id)) return false;
        if (anchors.some(function (anchor) { return anchor.id === candidate.id || anchor.handle === candidate.handle; })) return false;
        if (anchors.some(function (anchor) { return isHandleSibling(anchor.handle, candidate.handle); })) return false;
        if (hasExcludedTag(candidate) || isGiftCard(candidate)) return false;
        if (!candidate.curated && contextualSignalScore(candidate, anchors) < 50) return false;
        return availableVariants(candidate).length > 0;
      })
      .map(function (candidate) {
        var variants = availableVariants(candidate);
        candidate.availableVariants = variants;
        candidate.requiresChoice = variants.length > 1;
        candidate.score = scoreCandidate(candidate, anchors);
        candidate.rationale = rationaleFor(candidate, anchors);
        return candidate;
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        if (a.sourceRank !== b.sourceRank) return a.sourceRank - b.sourceRank;
        return a.title.localeCompare(b.title);
      })
      .slice(0, limit);
  }

  function titleTokens(product) {
    var stop = { and: true, the: true, for: true, with: true, from: true, made: true, rarely: true, complete: true };
    return unique(toString(product && product.title).toLowerCase().replace(/[^a-z0-9]+/g, ' ').split(' ').filter(function (token) {
      return token.length > 3 && !stop[token];
    }));
  }

  function rankCatalogFallbacks(anchors, catalog, cartProductIds, limit) {
    anchors = (anchors || []).map(normalizeProduct);
    var seen = Object.create(null);
    var dedupedCatalog = (catalog || []).filter(function (raw) {
      var key = toString(raw && (raw.id || raw.handle)).toLowerCase();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
    return dedupedCatalog.map(function (raw, index) {
      var candidate = normalizeProduct(raw);
      var signalScore = 0;
      anchors.forEach(function (anchor) {
        var interests = sharedInterests(anchor, candidate);
        signalScore += interests.length * 140;
        signalScore += sharedSegments(anchor, candidate).length * 120;
        if (sameUsefulVendor(anchor.vendor, candidate.vendor)) signalScore += 160;
        if (anchor.productType && candidate.productType && anchor.productType.toLowerCase() === candidate.productType.toLowerCase()) signalScore += 85;
        var candidateTokens = titleTokens(candidate);
        var sharedTitle = titleTokens(anchor).filter(function (token) { return candidateTokens.indexOf(token) !== -1; });
        signalScore += Math.min(2, sharedTitle.length) * 28;
      });
      if (candidate.price && anchors.some(function (anchor) { return anchor.price && candidate.price <= Math.max(8000, anchor.price * 0.75); })) signalScore += 18;
      candidate.fallbackScore = signalScore;
      candidate.sourceRank = 200 + index;
      return candidate;
    }).filter(function (candidate) {
      if (!candidate.id || !candidate.handle || !candidate.title) return false;
      if (cartHas(cartProductIds, candidate.id)) return false;
      if (anchors.some(function (anchor) { return anchor.id === candidate.id || anchor.handle === candidate.handle; })) return false;
      if (hasExcludedTag(candidate) || isGiftCard(candidate)) return false;
      return candidate.fallbackScore >= 100;
    }).sort(function (a, b) {
      if (b.fallbackScore !== a.fallbackScore) return b.fallbackScore - a.fallbackScore;
      return a.title.localeCompare(b.title);
    }).slice(0, Number(limit || 8));
  }

  var engine = {
    normalizeProduct: normalizeProduct,
    availableVariants: availableVariants,
    sharedInterests: sharedInterests,
    sharedSegments: sharedSegments,
    contextualSignalScore: contextualSignalScore,
    isHandleSibling: isHandleSibling,
    scoreCandidate: scoreCandidate,
    rationaleFor: rationaleFor,
    mergeCandidates: mergeCandidates,
    selectCandidates: selectCandidates,
    rankCatalogFallbacks: rankCatalogFallbacks
  };

  root.RarelyCartRecommendationsEngine = engine;

  if (typeof document === 'undefined' || typeof customElements === 'undefined' || typeof HTMLElement === 'undefined') return;

  function route(path) {
    var base = root.Shopify && root.Shopify.routes && root.Shopify.routes.root || '/';
    return base.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function withTimeout(url, options, timeout) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, timeout || 5000) : null;
    var settings = Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, options || {});
    if (controller) settings.signal = controller.signal;
    return fetch(url, settings).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          var error = new Error(payload.description || payload.message || 'Request failed');
          error.status = response.status;
          throw error;
        });
      }
      return response.json();
    }).finally(function () {
      if (timer) clearTimeout(timer);
    });
  }

  function cachedGet(url, timeout) {
    var now = Date.now();
    var cached = getCache.get(url);
    if (cached && now - cached.createdAt < GET_CACHE_TTL) return cached.promise;
    var promise = withTimeout(url, null, timeout).catch(function (error) {
      getCache.delete(url);
      throw error;
    });
    getCache.set(url, { createdAt: now, promise: promise });
    return promise;
  }

  function moneyFormatter(currency, locale) {
    try {
      return new Intl.NumberFormat(locale || document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 2
      });
    } catch (error) {
      return { format: function (value) { return '$' + Number(value || 0).toFixed(2); } };
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function publish(name, detail) {
    var payload = Object.assign({ event_name: name, component: 'rarely_cart_recommendations', version: '1.0.0' }, detail || {});
    try {
      if (root.Shopify && root.Shopify.analytics && typeof root.Shopify.analytics.publish === 'function') {
        root.Shopify.analytics.publish(name, payload);
      }
    } catch (error) {}
    try {
      if (Array.isArray(root.dataLayer)) root.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (error) {}
    document.dispatchEvent(new CustomEvent(name, { detail: payload }));
  }

  function experimentBucket() {
    var configured = root.RarelyCartRecommendationsConfig && root.RarelyCartRecommendationsConfig.bucket;
    return configured === 'compact' ? 'compact' : 'editorial';
  }

  class RarelyCartRecommendations extends HTMLElement {
    constructor() {
      super();
      this._connected = false;
      this._requestId = 0;
      this._products = [];
      this._context = null;
      this._bucket = experimentBucket();
      this._formatter = moneyFormatter('USD', 'en-US');
      this._impressionObserver = null;
      this._impressedProductIds = Object.create(null);
      this._cartUpdateTimer = null;
      this._boundClick = this._onClick.bind(this);
      this._boundChange = this._onChange.bind(this);
      this._boundCartUpdate = this._onCartUpdate.bind(this);
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.dataset.experiment = this._bucket;
      this.addEventListener('click', this._boundClick);
      this.addEventListener('change', this._boundChange);
      document.addEventListener('cart:update', this._boundCartUpdate);
      this._initialize();
    }

    disconnectedCallback() {
      if (this._impressionObserver) this._impressionObserver.disconnect();
      this._impressionObserver = null;
      this._requestId += 1;
      this._connected = false;
      this.removeEventListener('click', this._boundClick);
      this.removeEventListener('change', this._boundChange);
      document.removeEventListener('cart:update', this._boundCartUpdate);
      if (this._cartUpdateTimer) clearTimeout(this._cartUpdateTimer);
      this._cartUpdateTimer = null;
    }

    _onCartUpdate() {
      var self = this;
      if (this._cartUpdateTimer) clearTimeout(this._cartUpdateTimer);
      // Horizon morphs section markup synchronously from the cart:update event.
      // Re-read the server-rendered context after that morph; morphdom may retain
      // this custom-element instance, so connectedCallback alone is insufficient.
      this._cartUpdateTimer = setTimeout(function () {
        self._cartUpdateTimer = null;
        if (!self.isConnected) return;
        self._initialize();
      }, 100);
    }

    _initialize() {
      if (this.dataset.enabled === 'false') {
        this.hidden = true;
        return;
      }
      var script = this.querySelector('[data-cart-recommendation-context]');
      try {
        this._context = JSON.parse(script && script.textContent || '{}');
      } catch (error) {
        this._renderEmpty();
        return;
      }
      if (!this._context.items || !this._context.items.length) {
        this._renderEmpty();
        return;
      }
      this._formatter = moneyFormatter(this._context.currency || 'USD', this._context.locale || 'en-US');
      this._load();
    }

    _load() {
      var requestId = ++this._requestId;
      var cartItems = this._context.items.map(normalizeProduct);
      var anchors = cartItems.slice(0, 3);
      var cartProductIds = new Set(cartItems.map(function (item) { return item.id; }));
      var jobs = [];
      var self = this;
      anchors.forEach(function (anchor, anchorIndex) {
        jobs.push(self._fetchShopifyRecommendations(anchor, anchorIndex));
        jobs.push(self._fetchCuratedRecommendations(anchor, anchorIndex));
      });
      this._renderLoading();
      Promise.allSettled(jobs).then(function (results) {
        if (requestId !== self._requestId || !self.isConnected) return null;
        var candidates = [];
        results.forEach(function (result) {
          if (result.status === 'fulfilled') candidates = candidates.concat(result.value || []);
        });
        var selected = selectCandidates({ anchors: anchors, candidates: candidates, cartProductIds: cartProductIds, limit: 3 });
        if (selected.length >= 3) return { selected: selected, candidates: candidates };
        return self._fetchLiveCatalogFallbacks(anchors, cartProductIds).then(function (fallbacks) {
          return {
            candidates: candidates.concat(fallbacks),
            selected: selectCandidates({
              anchors: anchors,
              candidates: candidates.concat(fallbacks),
              cartProductIds: cartProductIds,
              limit: 3
            })
          };
        });
      }).then(function (result) {
        if (!result || requestId !== self._requestId || !self.isConnected) return;
        self._products = result.selected;
        if (!self._products.length) {
          self._renderEmpty();
          return;
        }
        self._renderProducts();
      }).catch(function () {
        self._renderEmpty();
      });
    }

    _fetchShopifyRecommendations(anchor, anchorIndex) {
      if (!anchor.id) return Promise.resolve([]);
      var url = route('recommendations/products.json') + '?product_id=' + encodeURIComponent(anchor.id) + '&limit=10&intent=related';
      return cachedGet(url, 5000).then(function (payload) {
        var products = payload.products || (Array.isArray(payload) ? payload : []);
        return products.map(function (product, index) {
          product = Object.assign({}, product);
          product.sourceRank = anchorIndex * 10 + index;
          product.sourceCount = 1;
          product.sourceProductIds = [anchor.id];
          return product;
        });
      }).catch(function () { return []; });
    }

    _fetchCuratedRecommendations(anchor, anchorIndex) {
      if (!root.RarelyAccessoryMap || typeof root.RarelyAccessoryMap.match !== 'function') return Promise.resolve([]);
      var rule = root.RarelyAccessoryMap.match(anchor);
      if (!rule || !rule.addons || !rule.addons.length) return Promise.resolve([]);
      return Promise.all(rule.addons.slice(0, 4).map(function (handle, index) {
        return cachedGet(route('products/' + encodeURIComponent(handle) + '.js'), 4000)
          .then(function (product) {
            product = Object.assign({}, product);
            product.curated = true;
            product.curatedRule = rule;
            product.sourceRank = -100 + anchorIndex * 10 + index;
            product.sourceCount = 1;
            product.sourceProductIds = [anchor.id];
            return product;
          })
          .catch(function () { return null; });
      })).then(function (products) { return products.filter(Boolean); });
    }

    _fetchLiveCatalogFallbacks(anchors, cartProductIds) {
      var queries = [];
      anchors.forEach(function (anchor) {
        if (usefulVendor(anchor.vendor)) queries.push(anchor.vendor);
        interestTokens(anchor).slice(0, 2).forEach(function (interest) { queries.push(interest.replace(/[-_]+/g, ' ')); });
        if (anchor.productType && anchor.productType.length > 2) queries.push(anchor.productType);
        titleTokens(anchor).slice(0, 2).forEach(function (token) { queries.push(token); });
      });
      queries = unique(queries).slice(0, 6);
      if (!queries.length) return Promise.resolve([]);

      var searchJobs = queries.map(function (query) {
        var params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'product');
        params.set('resources[limit]', '10');
        params.set('resources[options][unavailable_products]', 'hide');
        return cachedGet(route('search/suggest.json') + '?' + params.toString(), 4500)
          .then(function (payload) {
            return payload && payload.resources && payload.resources.results && payload.resources.results.products || [];
          })
          .catch(function () { return []; });
      });

      return Promise.all(searchJobs).then(function (groups) {
        var shortlist = rankCatalogFallbacks(
          anchors,
          groups.reduce(function (all, group) { return all.concat(group); }, []),
          cartProductIds,
          6
        );
        return Promise.all(shortlist.map(function (candidate, index) {
          return cachedGet(route('products/' + encodeURIComponent(candidate.handle) + '.js'), 4500)
            .then(function (product) {
              product = Object.assign({}, product);
              product.sourceRank = 100 + index;
              product.sourceCount = 1;
              product.discoverySignal = candidate.fallbackScore;
              product.sourceProductIds = anchors.map(function (anchor) { return anchor.id; });
              return product;
            })
            .catch(function () { return null; });
        })).then(function (products) { return products.filter(Boolean); });
      });
    }

    _renderLoading() {
      this.hidden = false;
      this.setAttribute('aria-busy', 'true');
      var list = this.querySelector('[data-recommendation-list]');
      var status = this.querySelector('[data-recommendation-status]');
      if (list) {
        list.replaceChildren();
        for (var i = 0; i < 2; i += 1) list.appendChild(element('div', 'rarely-cart-rec__skeleton'));
      }
      if (status) status.textContent = 'Finding useful companions for your cart.';
    }

    _renderEmpty() {
      this.setAttribute('aria-busy', 'false');
      this.hidden = true;
      var list = this.querySelector('[data-recommendation-list]');
      if (list) list.replaceChildren();
    }

    _renderProducts() {
      var list = this.querySelector('[data-recommendation-list]');
      var status = this.querySelector('[data-recommendation-status]');
      if (!list) return;
      list.replaceChildren();
      this._products.forEach(function (product, index) {
        list.appendChild(this._productCard(product, index));
      }, this);
      this.setAttribute('aria-busy', 'false');
      this.hidden = false;
      if (status) status.textContent = this._products.length + ' recommendations ready.';
      this._observeImpressions();
    }

    _observeImpressions() {
      var self = this;
      var cards = this.querySelectorAll('.rarely-cart-rec__card');
      var publishCard = function (card) {
        var index = Number(card.dataset.rank) - 1;
        var product = self._products[index];
        var key = product && (product.id || product.handle);
        if (!product || !key || self._impressedProductIds[key]) return;
        self._impressedProductIds[key] = true;
        publish('rarely_cart_recommendation_impression', self._analyticsPayload(product, index));
      };
      if (typeof root.IntersectionObserver !== 'function') {
        cards.forEach(publishCard);
        return;
      }
      if (this._impressionObserver) this._impressionObserver.disconnect();
      this._impressionObserver = new root.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
          publishCard(entry.target);
          self._impressionObserver.unobserve(entry.target);
        });
      }, { threshold: [0.35] });
      cards.forEach(function (card) { self._impressionObserver.observe(card); });
    }

    _productCard(product, index) {
      var card = element('article', 'rarely-cart-rec__card');
      card.dataset.productId = product.id;
      card.dataset.rank = String(index + 1);

      var imageLink = element('a', 'rarely-cart-rec__image-link');
      imageLink.href = product.url;
      imageLink.setAttribute('aria-label', 'View ' + product.title);
      imageLink.dataset.recommendationNavigate = 'true';
      if (product.featuredImage) {
        var image = element('img', 'rarely-cart-rec__image');
        image.src = this._imageUrl(product.featuredImage, 220);
        image.alt = product.title;
        image.loading = 'lazy';
        image.width = 110;
        image.height = 110;
        imageLink.appendChild(image);
      }

      var body = element('div', 'rarely-cart-rec__body');
      if (product.vendor) body.appendChild(element('span', 'rarely-cart-rec__vendor', product.vendor));
      var title = element('a', 'rarely-cart-rec__title', product.title.split(' | ')[0]);
      title.href = product.url;
      title.dataset.recommendationNavigate = 'true';
      body.appendChild(title);
      body.appendChild(element('p', 'rarely-cart-rec__reason', product.rationale));
      var price = product.availableVariants.length ? product.availableVariants[0].price : product.price;
      var priceCopy = (product.availableVariants.length > 1 ? 'From ' : '') + this._formatter.format(price / 100);
      body.appendChild(element('span', 'rarely-cart-rec__price', priceCopy));
      body.appendChild(this._actions(product, index));

      card.appendChild(imageLink);
      card.appendChild(body);
      return card;
    }

    _actions(product, index) {
      var wrapper = element('div', 'rarely-cart-rec__actions');
      if (!product.requiresChoice) {
        var add = element('button', 'rarely-cart-rec__button', 'Add');
        add.type = 'button';
        add.dataset.recommendationAdd = 'true';
        add.dataset.variantId = product.availableVariants[0].id;
        add.dataset.productIndex = String(index);
        wrapper.appendChild(add);
        return wrapper;
      }

      var choose = element('button', 'rarely-cart-rec__button rarely-cart-rec__button--choose', 'Choose options');
      choose.type = 'button';
      choose.dataset.recommendationChoose = 'true';
      choose.dataset.productIndex = String(index);
      choose.setAttribute('aria-expanded', 'false');
      wrapper.appendChild(choose);

      var panel = element('div', 'rarely-cart-rec__variant-panel');
      panel.hidden = true;
      panel.dataset.variantPanel = String(index);
      var label = element('label', 'rarely-cart-rec__variant-label', 'Choose a variant');
      var select = element('select', 'rarely-cart-rec__variant-select');
      select.dataset.recommendationVariant = 'true';
      select.dataset.productIndex = String(index);
      select.setAttribute('aria-label', 'Choose a variant for ' + product.title);
      var placeholder = element('option', '', 'Select an option');
      placeholder.value = '';
      select.appendChild(placeholder);
      product.availableVariants.forEach(function (variant) {
        var option = element('option', '', variant.title + ' — ' + this._formatter.format(variant.price / 100));
        option.value = variant.id;
        select.appendChild(option);
      }, this);
      label.appendChild(select);
      panel.appendChild(label);
      var addSelected = element('button', 'rarely-cart-rec__button', 'Add selected');
      addSelected.type = 'button';
      addSelected.dataset.recommendationAdd = 'true';
      addSelected.dataset.productIndex = String(index);
      addSelected.disabled = true;
      panel.appendChild(addSelected);
      wrapper.appendChild(panel);
      return wrapper;
    }

    _imageUrl(source, width) {
      var url = toString(source);
      if (!url) return '';
      try {
        var parsed = new URL(url, root.location && root.location.origin || 'https://rarely.co');
        parsed.searchParams.set('width', String(width));
        return parsed.toString();
      } catch (error) {
        return url;
      }
    }

    _onClick(event) {
      var choose = event.target.closest && event.target.closest('[data-recommendation-choose]');
      if (choose && this.contains(choose)) {
        var index = Number(choose.dataset.productIndex);
        var panel = this.querySelector('[data-variant-panel="' + index + '"]');
        if (panel) {
          panel.hidden = !panel.hidden;
          choose.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
          if (!panel.hidden) {
            var select = panel.querySelector('select');
            if (select) select.focus();
          }
        }
        publish('rarely_cart_recommendation_variant_opened', this._analyticsPayload(this._products[index], index));
        return;
      }

      var add = event.target.closest && event.target.closest('[data-recommendation-add]');
      if (add && this.contains(add)) {
        var productIndex = Number(add.dataset.productIndex);
        var product = this._products[productIndex];
        var variantId = add.dataset.variantId;
        if (!variantId) {
          var selectNode = this.querySelector('[data-recommendation-variant][data-product-index="' + productIndex + '"]');
          variantId = selectNode && selectNode.value;
        }
        if (product && variantId) this._addProduct(product, productIndex, variantId, add);
        return;
      }

      var navigate = event.target.closest && event.target.closest('[data-recommendation-navigate]');
      if (navigate && this.contains(navigate)) {
        var card = navigate.closest('[data-product-id]');
        var rank = card ? Number(card.dataset.rank) - 1 : -1;
        publish('rarely_cart_recommendation_opened', this._analyticsPayload(this._products[rank], rank));
      }
    }

    _onChange(event) {
      var select = event.target.closest && event.target.closest('[data-recommendation-variant]');
      if (!select || !this.contains(select)) return;
      var index = Number(select.dataset.productIndex);
      var panel = select.closest('[data-variant-panel]');
      var button = panel && panel.querySelector('[data-recommendation-add]');
      if (button) button.disabled = !select.value;
      publish('rarely_cart_recommendation_variant_selected', Object.assign(
        this._analyticsPayload(this._products[index], index),
        { variant_id: toString(select.value) }
      ));
    }

    _addProduct(product, index, variantId, button) {
      var self = this;
      var original = button.textContent;
      var sectionIds = unique(Array.prototype.map.call(
        document.querySelectorAll('cart-items-component[data-section-id]'),
        function (component) { return component.dataset.sectionId; }
      ));
      button.disabled = true;
      button.textContent = 'Adding…';
      publish('rarely_cart_recommendation_add_attempted', Object.assign(
        this._analyticsPayload(product, index),
        { variant_id: toString(variantId) }
      ));
      withTimeout(route('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: toString(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: root.location && root.location.pathname || '/cart'
        })
      }, 8000).then(function (addResponse) {
        button.textContent = 'Added';
        var status = self.querySelector('[data-recommendation-status]');
        if (status) status.textContent = product.title + ' was added to your cart.';
        publish('rarely_cart_recommendation_add_succeeded', Object.assign(
          self._analyticsPayload(product, index),
          { variant_id: toString(variantId) }
        ));
        return withTimeout(route('cart.js'), null, 5000).then(function (cart) {
          var badge = document.getElementById('cart-badge');
          if (badge) badge.textContent = cart.item_count;
          var toggle = document.getElementById('cart-toggle');
          if (toggle) toggle.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count,
                source: 'rarely-cart-recommendations',
                sections: addResponse.sections || {}
              }
            }
          }));
        });
      }).catch(function (error) {
        button.disabled = false;
        button.textContent = original;
        var status = self.querySelector('[data-recommendation-status]');
        if (status) status.textContent = error.message || 'That item could not be added. Please try again.';
        publish('rarely_cart_recommendation_add_failed', Object.assign(
          self._analyticsPayload(product, index),
          { variant_id: toString(variantId), error: toString(error.message), status: error.status || null }
        ));
      });
    }

    _analyticsPayload(product, index) {
      product = product || {};
      return {
        experiment: 'rarely_cart_recommendations_v1',
        bucket: this._bucket,
        product_id: toString(product.id),
        product_handle: toString(product.handle),
        vendor: toString(product.vendor),
        rank: index >= 0 ? index + 1 : null,
        score: product.score || null,
        rationale: toString(product.rationale),
        curated_rule: product.curatedRule && product.curatedRule.id || null,
        source_product_ids: product.sourceProductIds || [],
        cart_product_ids: (this._context.items || []).map(function (item) { return toString(item.id); }),
        surface: this.closest('.cart-drawer') ? 'cart_drawer' : 'cart_page'
      };
    }
  }

  if (!customElements.get('rarely-cart-recommendations')) {
    customElements.define('rarely-cart-recommendations', RarelyCartRecommendations);
  }
})(typeof window !== 'undefined' ? window : this);
